import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0 }) => (
    <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, delay, ease: [0.2, 0.7, 0.2, 1] }}
    >
        {children}
    </motion.div>
);

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative bg-cream py-28 md:py-48 overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-8 md:gap-16">
                <div className="col-span-12 md:col-span-4">
                    <Reveal>
                        <span className="font-sans text-[10px] uppercase tracking-[0.4em] text-oxblood">
                            № I - Philosophy
                        </span>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <p className="mt-10 font-sans text-[11px] uppercase tracking-[0.3em] text-[#595959] leading-[2]">
                            Worldwide
                            <br />
                            Discreet
                            <br />
                            Without limit
                        </p>
                    </Reveal>
                </div>

                <div className="col-span-12 md:col-span-8 md:pl-8">
                    <Reveal>
                        <h2 className="font-serif text-[2.6rem] md:text-[4rem] leading-[1.02] tracking-tight">
                            We facilitate the smallest detail
                            <br />
                            to the{" "}
                            <span className="italic">most unusual request.</span>
                        </h2>
                    </Reveal>

                    <Reveal delay={0.25}>
                        <p className="mt-12 font-sans text-[15px] md:text-[17px] leading-[1.9] text-[#1A1A1A]/85 max-w-3xl">
                            Monplaisir is the private operating arm of a luxury facilitation
                            house, shaped through years of service within the world's most
                            exclusive circles. Entrusted with dignitaries, artists and
                            private individuals who prefer discretion over display.
                        </p>
                    </Reveal>

                    <Reveal delay={0.32}>
                        <p className="mt-8 font-sans text-[15px] md:text-[17px] leading-[1.9] text-[#1A1A1A]/85 max-w-3xl">
                            A worldwide chauffeur and travel companion service, equally
                            comfortable arranging private jets, yachts, the relocation of
                            beloved animals and automobiles, or orchestrating the evening
                            before the idea has fully formed.
                        </p>
                    </Reveal>

                    <Reveal delay={0.45}>
                        <p className="mt-14 font-serif italic text-[22px] md:text-[28px] text-oxblood leading-snug max-w-3xl">
                            "Integrity and discretion are paramount at Monplaisir."
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
